module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAwCAYAAABqkJjhAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ1JREFUeNrsl/0NgjAQxQ/iAB2BUdjAFToKIzBCR9ANcANH6AjdoB6m0UTbQ7R81LyXPP6g9/ELacqVvPeU2Zptg3Xu+kuAvioreI4ibQI0Bt5uCTw2H/x8Db+ArwmaBXxOcMM2Pr9MqJ0NeCnQr8ClRcXu/frqQ++Pgcfgju38dnKBQUnAewCdBJ869Peix8+n4seJiI5Uhs41PxSVI1VTYQLw0qruRwW+MIDLBT5E3jVsnYi3bJNYa4NjGoJj0qFnTCb0fCoxoEtDd2q664S8TsiTLgNvAz72MIABDGAAAxjAAAZwafOwY18S8VehlhXyrJAn1XS4hAL4H4HHy6EvxAO2BIABDGBZNwEGACLEb3qb5S5bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/school_signin_icon.png
// module id = 1089
// module chunks = 0